export default __webpack_public_path__ + "static/media/WIBI.2765c0e5.png";